import { render, staticRenderFns } from "./updateaccounttype.vue?vue&type=template&id=352d423e&"
import script from "./updateaccounttype.vue?vue&type=script&lang=js&"
export * from "./updateaccounttype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports